<template>
  <div class="menu" @click="clickHandler">
    <div class="sort">
      <div>
        {{ sortText }}
      </div>
      <div class="triangle" :style="triangleStyle">
      </div>
    </div>
    <div class="filter" v-if="showFilter">
      <div class="line">
      </div>
      <div>
        筛选显示
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    computed : {
      ...mapState( 'virusTrip', [ 'searchType', 'sortMode' ] ),

      sortText() {
        let result;

        const sortModeTextMap = {
          publishTimeDescend : '发布日期由晚到早',
          publishTimeAscend  : '发布日期由早到晚',
          dateDescend        : '行程日期由晚到早',
          dateAscend         : '行程日期由早到晚'
        };

        result = sortModeTextMap[ this.sortMode ];

        return result;
      },

      showFilter() {
        return this.searchType !== 'train' && this.searchType !== 'flight';
      },

      triangleStyle() {
        return this.showFilter ? {
          marginRight : '10px'
        } : {
          marginRight : '16px'
        };
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'updateSortMode', 'updateShowMenuWindow'
      ] ),

      clickHandler() {
        this.updateShowMenuWindow( true );
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./menu-panel.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/menu-panel.vue